import { Button, Text } from '@fluentui/react-components';
import { Dismiss16Regular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getFileIcon } from '../../common/file-icon/get-file-icon';
import './DocumentFile.scss';
import { FlexBox } from './flex-box';

interface DocumentFileProps {
  filename: string;
  onDownloadFile?: () => void;
  onDeleteFile?: () => void;
}

const DocumentFile: React.FC<DocumentFileProps> = props => {
  const { onDownloadFile, onDeleteFile, filename } = props;
  return (
    <FlexBox
      aligns='center'
      className='document-file'
    >
      <img
        src={getFileIcon(filename)}
        alt='file icon'
        aria-hidden
        width={14}
        height={16}
      />
      {
        onDownloadFile ? (
          <Button
            appearance='transparent'
            onClick={onDownloadFile}
            size='small'
          >
            {filename}
          </Button>
        ) : <Text weight='semibold'>{filename}</Text>
      }
      {
        !!onDeleteFile &&
        <Button
          appearance='transparent'
          onClick={onDeleteFile}
          icon={<Dismiss16Regular />}
          title='delete'
          size='small'
        />
      }
    </FlexBox >
  );
}

export default observer(DocumentFile);
